import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LocationsService } from '@core/services';
import { ClusterPoint, VehicleCluster } from '@gozetta/z-maps/vehicles';
import { US_BOUNDS } from '@feature/live-map/constants';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

/**
 * Fetches initial vehicle clusters using the current user's accessible locations.
 * The result is used by LiveMapComponent to fit the map to the user's vehicle footprint.
 * Falls back to an empty array on error so the map still loads.
 */
export const liveMapBoundsResolver: ResolveFn<ClusterPoint[]> = () => {
  const clusterService = inject(VehicleCluster);
  const locationsService = inject(LocationsService);

  const locationIds = toSignal(locationsService.selectedLocationsIds$, {
    requireSync: true,
  });

  return clusterService
    .fetchClusters(
      US_BOUNDS,
      { locationIds: locationIds(), vehicleNames: [] },
      2
    )
    .pipe(catchError(() => of([])));
};
